<!-- @format -->
<template>
    <div class="d-flex flex-column align-center justify-center u-height-100">
        <BaseImage
            ref="image"
            :src="imageUrl"
            height="auto"
            :width="$vuetify.breakpoint.mdAndUp ? 400 : 222">
            <template v-slot:fallback>
                <v-flex
                    class="gst-ticket-no-seats-available d-flex flex-column align-center justify-center u-height-100">
                    <BaseIcon
                        class="gst-ticket-no-seats-available__image mb-2"
                        :width="width"
                        :height="height"
                        symbol-id="icons--no_seats_available" />
                    <template v-if="$slots.default">
                        <slot></slot>
                    </template>
                    <h5
                        v-else
                        class="mb-2 text-center">
                        {{ $t('_common:messages.noSeats.title') }}
                    </h5>
                </v-flex>
            </template>
        </BaseImage>
    </div>
</template>

<script>
export default {
    name: 'TicketNoSeatsAvailable',
    props: {
        width: {
            type: [String, Number],
            default: null,
        },
        height: {
            type: [String, Number],
            default: null,
        },
        imageUrl: {
            type: String,
            default: null,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-ticket-no-seats-available {
    .gst-ticket-no-seats-available__image {
        ::v-deep .gst-svg-icon {
            fill: theme-color('primary');
        }
    }

    h5 {
        line-height: line-height('l');
        font-size: font-size('s');
        font-weight: font-weight('medium');
        letter-spacing: -0.41px;
    }
}
</style>
